
const config = {
  links: {
    dev: {
      dqExplorer: "https://dq-explorer-ui.dev.arm.gov/",
      dqPlotbrowser: "https://dq-plotbrowser-ui.dev.arm.gov/",
      dqZoom: "https://dq-zoom-ui.dev.arm.gov/",
      dqDashboard: "https://dq-dashboard-ui.dev.arm.gov/"
    },
    stage: {
      dqExplorer: "https://dq-explorer-ui.stg.arm.gov/",
      dqPlotbrowser: "https://dq-plotbrowser-ui.stg.arm.gov/",
      dqZoom: "https://dq-zoom-ui.stg.arm.gov/",
      dqDashboard: "https://dq-dashboard-ui.stg.arm.gov/"
    },
    prod: {
      dqExplorer: "https://dq-explorer-ui.svcs.arm.gov/",
      dqPlotbrowser: "https://dq-plotbrowser-ui.svcs.arm.gov/",
      dqZoom: "https://dq-zoom-ui.svcs.arm.gov/",
      dqDashboard: "https://dq-dashboard-ui.svcs.arm.gov/"
    }
  }
}

export default config;
